import React from 'react';
import PropTypes from 'prop-types';
import {
  Link, Modal, ModalContent, ImageContainer, ModalImage,
} from '../styles';

export const ImageModal = ({ imageUrl, isOpen, setIsOpen }) => (
  <Modal
    open={isOpen}
    onClose={() => setIsOpen(false)}
    closeIcon
  >
    <ModalContent>
      <ImageContainer>
        <ModalImage
          src={imageUrl}
        />
      </ImageContainer>
      <Link onClick={() => setIsOpen(false)}>
        Exit Image Preview
      </Link>
    </ModalContent>
  </Modal>
);

// proptypes
ImageModal.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
};
